import { render, staticRenderFns } from "./SchoolListsBaseForm.vue?vue&type=template&id=7d135df2"
import script from "./SchoolListsBaseForm.vue?vue&type=script&lang=js"
export * from "./SchoolListsBaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports